/* @flow */

import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import Styled from 'styled';
import withInnerRef from 'lib/react/with-inner-ref';
import defaultStyles from './autocomplete-view.scss';

@observer
class AutocompleteItemView extends React.Component {
    onClick = event => {
        this.props.onClick(event, this.props.item);
    };

    render() {
        const { styles } = this.props;

        return (
            <button className={styles.button} type='button' onClick={this.onClick}>
                {this.props.children}
            </button>
        );
    }
}

@Styled(defaultStyles)
class AutocompleteView extends React.Component {
    @observable selected: ?User;

    @action select(props: { items: ?(User[]) } = this.props) {
        const { items } = props;

        if (items && items.length) {
            this.selected = items[0];
        } else {
            this.selected = null;
        }
    }

    @action selectNext = () => {
        const { selected } = this;
        const { items } = this.props;

        if (items && items.length && selected) {
            const index = items.indexOf(selected);

            if (index !== -1) {
                if (index + 1 < items.length) {
                    this.selected = items[index + 1];
                } else {
                    this.selected = items[0];
                }
            }
        }
    };

    @action selectPrevious = () => {
        const { selected } = this;
        const { items } = this.props;

        if (items && items.length && selected) {
            const index = items.indexOf(selected);

            if (index !== -1) {
                if (index - 1 < 0) {
                    this.selected = items[items.length - 1];
                } else {
                    this.selected = items[index - 1];
                }
            }
        }
    };

    UNSAFE_componentWillMount() {
        this.select();
    }

    componentWillReceiveProps(props: { items: ?(any[]) }) {
        this.select(props);
    }

    render() {
        const { styles, items, elementForItem, keyForItem, onClick } = this.props;

        return (
            <ul className={styles.autocomplete}>
                {items
                    ? items.map(item => (
                          <li key={keyForItem(item)} className={styles.item}>
                              <AutocompleteItemView item={item} onClick={onClick} styles={styles}>
                                  {React.cloneElement(elementForItem(item), {
                                      selected: item === this.selected,
                                  })}
                              </AutocompleteItemView>
                          </li>
                      ))
                    : null}
            </ul>
        );
    }
}

export default AutocompleteView;
